import { useAppDispatch, useAppSelector } from "../../app";
import { RefObject, useCallback, useEffect } from "react";
import { GroupBlockEntityType } from "../";
import { changeScrollToEntity } from "../../app/store/appSlice";

type Props = {
  ref: RefObject<HTMLDivElement | null>;
  entity: GroupBlockEntityType;
  groupBlockIndex: number;
};

const useScroll = ({ ref, entity, groupBlockIndex }: Props) => {
  const dispatch = useAppDispatch();
  const { scrollIntoView } = useAppSelector((state) => state.appReducer);

  const scrollToHotKey = useCallback(
    (entityToScroll: GroupBlockEntityType) => {
      if (!ref.current) {
        return;
      }

      if (entityToScroll.entityType.id !== entity.entityType.id) {
        return;
      }

      if (groupBlockIndex !== entityToScroll.index) {
        return;
      }

      // Skip scrolling for virtualized tables to prevent table container from expanding
      const virtualTable = ref.current.closest(".group-block-table");
      if (virtualTable) {
        dispatch(changeScrollToEntity(undefined));
        return;
      }

      // For non-table elements, use scrollIntoView
      dispatch(changeScrollToEntity(undefined));
      ref.current.scrollIntoView({ behavior: "smooth", block: "nearest" });
    },
    [groupBlockIndex, entity, ref, dispatch],
  );

  useEffect(() => {
    if (scrollIntoView) {
      scrollToHotKey(scrollIntoView);
    }
  }, [scrollIntoView, scrollToHotKey, ref]);
};

export default useScroll;
